export default __webpack_public_path__ + "static/media/material2.8a29525c.svg";